<template>
  <div>
    <!-- inicio modal -->
    <b-modal modal-class="modalAddSepultamento"
             body-class="modalAddSepultamento_body"
             :hide-header="true"
             :visible="true"
             centered
             size="xl"
             no-close-on-backdrop
             no-close-on-esc
             @hide="modalControler().hideModal()">
      <!-- @ok="modalChanged"
             @hide="verifyReset">-->
      <div class="row align-items-end">
        <div class="col-sm-9">
          <div class="form-group">
            <label
              class="label"
              for="localSepulta">Nome do Local de Sepultamento</label>
            <input
              id="localSepulta"
              v-model="form.nome"
              class="form-control form-control-sm"
              name="localSepulta"
              placeholder="Cemitério São Paulo"
              type="text"
              @keydown.enter="searchSepultamentos()">
            <!--@keyup.enter="searchLocalSepultamento() , showSepult()">-->
          </div>
          <BoxEndereco
            :no-header="true"
            :data="form.endereco"
            :endereco-disable="false" />
        </div>
        <div class="col-auto">
          <div class="form-group">
            <button
              class="btn btn-sm btn-primary Sepultamento--btn-search"
              type="button"
              @click="searchSepultamentos()">
              Pesquisar Local
            </button>
          </div>
        </div>
      </div>
      <!-- listagem dados -->
      <div class="row mb-2">
        <div v-if="listSepultamentos.length > 0 && show.searched"
             class="col">
          <label class="label">Escolha uma das opções. Caso não a encontre, você poderá prosseguir com as informações que estiverem preenchidas.</label>
          <div v-for="(sepultamento, index) in listSepultamentos"
               :key="`${ _uid }_sepultamento_listado_${ index }`"
               class="row">
            <div class="col">
              <span
                :key="sepultamento.sepultamento_sugestao_id"
                class="custom-control custom-radio">
                <input
                  :id="`local-sepultamento_${sepultamento.sepultamento_sugestao_id}`"
                  v-model="sepultamentoSelecionado"
                  :value="sepultamento"
                  type="radio"
                  name="cemiterioSelecionada"
                  class="custom-control-input"
                  @keyup.enter="sepultamentoSelecionado = sepultamento">
                <label
                  class="custom-control-label"
                  :for="`local-sepultamento_${sepultamento.sepultamento_sugestao_id}`">
                  {{ sepultamento.nome }} - {{ sepultamento.endereco | Endereco }}
                </label>
              </span>
            </div>
          </div>

          <div class="row">
            <div class="col-8">
              <Pagination :page="pagination.page"
                          :last-page="pagination.lastPage || 1"
                          @onPreviousPage="modalControler().changePage(-1)"
                          @onNextPage="modalControler().changePage(+1)" />
            </div>
          </div>
        </div>

        <!-- informativo caso esteja zerado -->
        <div v-if="listSepultamentos.length == 0 && show.searched"
             class="col">
          <p class="mb-0 itemPadding">
            <small><strong>Nenhum resultado encontrado.</strong>
              <br> Talvez este local não esteja cadastrado ainda no nosso banco de dados ou você esteja sem conexão com a internet.
              <br> Caso este local não esteja cadastrado, ele será cadastrado ao final do preenchimento desse registro.
              <br> </small>
          </p>
        </div>
      </div>

      <!-- endereco completo -->
      <div class="row">
        <div class="col">
          <label class="label">Gostaria de preencher e mostrar na certidão o endereço completo do local?</label>
          <div>
            <span class="custom-control custom-radio custom-control-inline">
              <input
                id="completoSim"
                v-model="sepultamentoCertidao"
                type="radio"
                name="completoSim"
                :value="true"
                class="custom-control-input"
                @keyup.enter="sepultamentoCertidao = true">
              <label
                class="custom-control-label"
                for="completoSim">Sim</label>
            </span>

            <span class="custom-control custom-radio custom-control-inline">
              <input
                id="completoNao"
                v-model="sepultamentoCertidao"
                type="radio"
                name="completoNao"
                :value="false"
                class="custom-control-input"
                @keyup.enter="sepultamentoCertidao = false">
              <label
                class="custom-control-label"
                for="completoNao">Não</label>
            </span>
          </div>
        </div>
      </div>
      <div v-if="addressCompleted"
           class="row">
        <div class="col">
          <BoxEndereco
            :no-header="true"
            :prop-validator="true"
            :data="form.endereco"
            @onEnderecoAdd="getSepultamentoAddress" />
        </div>
      </div>

      <!-- footer modal -->
      <div slot="modal-footer"
           slot-scope="{ ok, cancel }"
           class="modalAddGenitor_footer">
        <button class="btn btn-sm btn-dark mr-2"
                type="button"
                @click="modalControler().hideModal()">
          Voltar
        </button>
        <button v-if="!vefiryObject(propSepultamento)"
                class="btn btn-sm btn-primary mr-2"
                :disabled="(form.nome && !show.searched) && !show.edit"
                type="button"
                @click="saveSepultamento">
          Adicionar
        </button>
        <button v-else
                class="btn btn-sm btn-primary mr-2"
                type="button"
                :disabled="(!form.nome && listSepultamentos.length == 0) && !vefiryObject(sepultamentoSelecionado) || ! form.nome"
                @click="saveSepultamento">
          Editar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* components */
  import BoxEndereco from '@/components/SofiaRei/BoxEndereco.vue'
  import Pagination from '../../../../Pagination'

  /* services */
  import SepultamentoSugestaoService from "@/services/Registros/Obito/SepultamentoSugestaoService"

  export default {
    name: "SepultamentoModal",
    components: {
      BoxEndereco,
      Pagination
    },
    props: {
      propSepultamento: {
        type: Object,
        default: () => ({})
      },
      propSepultamentoCertidao: {
        type: [Number, Boolean],
        default: () => (false)
      },
      propEdit: {
        type: Boolean,
        default: () => (false)
      },
      propCartorio: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return  {
        sepultamentoCertidao: false,
        // controla oq eh mostrado
        show: {
          modalOpen: false,
          searched: false,
          edit: false
        },
        form: {
          nome: null,
          endereco: {
            uf: null,
            cidade: null,
            numero: null,
            bairro: null,
            ibge: null,
            logradouro: null
          }
        },
        pagination: {
          page: 1,
          lastPage: null,
          total: null
        },
        listSepultamentos: [],
        // quando um sepultamento listado for selecionado
        sepultamentoSelecionado: {}
      }
    },
    computed: {
      addressCompleted () {
        return (this.sepultamentoCertidao && this.show.searched && !this.vefiryObject(this.sepultamentoSelecionado))
      }
    },
    watch: {
      propSepultamento () {
        this.init()
      },
      propEdit () {
        this.init()
      },
      propCartorio () {
        this.init()
      }
    },
    created () {
      this.init()
    },
    methods: {
      async init () {
        // atualizando sepultamento local
        if (this.propEdit) {
          await this.editSepultamento()
        }

        if (!this.propEdit && this.propCartorio.endereco) {
          this.form.endereco.uf = this.propCartorio.endereco.uf
          this.form.endereco.cidade = this.propCartorio.endereco.cidade
          this.form.endereco.ibge = this.propCartorio.endereco.ibge
        }
      },
      /* controla as acoes visiveis do modal */
      modalControler () {
        const showModal = () => {
          this.show.modalOpen = true
        }

        const hideModal = () => {
          this.$emit('onHideModal')
        }

        const resetModal = () => {
          this.sepultamentoSelecionado = {}
          Object.assign(this.form, { sepultamento_sugestao_id: null })
          Object.assign(this.form.endereco, {
            bairro: null,
            numero: null,
            complemento: null,
            cep: null,
            logradouro: null,
            endereco_id: null
          })
        }

        const changePage = (page) => {
          this.pagination.page = this.pagination.page + page
          this.searchSepultamentos()
        }

        return { showModal, hideModal, resetModal, changePage }
      },
      /* busca dados do sepultamento */
      async searchSepultamentos () {
        try {
          loader({ active: true, text: 'Buscando sepultamentos...' })
          const payload = {
            cartorio_id: this.$store.state.auth.cartorio_id,
            nome: this.form.nome,
            cidade: this.form.endereco.cidade,
            uf: this.form.endereco.uf,
            page: this.pagination.page,
            ativo: 1
          }

          const { data, perPage, total, page, lastPage } = await SepultamentoSugestaoService.getSepultamentoSugestao(payload)

          if (data.length == 0) {
            this.modalControler().resetModal()
          }

          Object.assign(this.pagination, { perPage, total, page, lastPage })

          this.show.searched = true

          this.listSepultamentos = data
        } catch (e) {
          console.error(e)
        } finally {
          loader({ active: false })
        }
      },
      // atualizando endereco do form
      getSepultamentoAddress (endereco) {
        Object.assign(this.form.endereco, endereco)
      },

      // salvando sepultamento principal
      saveSepultamento () {
        if (this.vefiryObject(this.sepultamentoSelecionado)) {
          this.form.nome = this.sepultamentoSelecionado.nome
          Object.assign(this.sepultamentoSelecionado, this.form)
          this.$emit('onSaveSepultamento', Object.assign(this.sepultamentoSelecionado, { sepultamento_certidao: this.sepultamentoCertidao }))
          this.modalControler().hideModal()
        } else {
          if (this.sepultamentoCertidao) {
            const { uf, cidade } = this.form.endereco

            if (!!uf && !!cidade) {
              this.$emit('onSaveSepultamento', Object.assign(this.form, { sepultamento_certidao: this.sepultamentoCertidao }))
              this.modalControler().hideModal()
            } else {
              objSwal.info.title = 'Erro ao salvar sepultamento!'
              objSwal.info.text = 'Dados faltantes de endereço'
              objSwal.info.html = ''
              Swal.fire(objSwal.info)
            }
          } else {
            this.$emit('onSaveSepultamento', Object.assign(this.form, { sepultamento_certidao: this.sepultamentoCertidao }))
            this.modalControler().hideModal()
          }

        }
      },

      // excluindo sepultamento
      removeSepultamento () {
        this.$emit('onRemoveSepultamento')
      },

      // abrir modal pra editar sepultamento
      async editSepultamento () {
        this.form = { ...this.propSepultamento }
        this.sepultamentoSelecionado = { ...this.propSepultamento }
        Object.assign(this.show, { edit: this.propEdit })
        this.sepultamentoCertidao = !!this.propSepultamentoCertidao

        await this.searchSepultamentos()
        this.modalControler().showModal()
      },
      vefiryObject (obj) {
        return !!obj && Object.values(obj).length > 0 || false
      },
      setSepultamentoCertidao (value) {
        this.sepultamentoCertidao = value
      }
    }
  }
</script>


<style scoped lang="scss">
  .Sepultamento {
    &--btn-search {
      position: relative;
      right: 400px;
      top:-10px;
    }
  }

  .btn-add-sepultamento:hover > [class*=icon-add] {
    fill: #fff !important;
  }

  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }

</style >
